import { ProgressBar } from "components/UI/atoms";
import { useCartContext } from "context/cart-context";
import { useCartCountdown } from "context/cart-context/utils/useCartCountdown";
import { useAppContext } from "context/app-context";
import { secondsToTime } from "utils/numbers";
import { calculateTimerColor } from "utils/timer";
import { getMessageByCount } from "utils/format";
import "./index.scss";

export const CartHeader = () => {
  const {
    sessionInfo: { userID }
  } = useAppContext();
  const {
    cart,
    cart: { timeIsUp, cards },
    emptyCart
  } = useCartContext();
  const countdown = useCartCountdown(cart, () => emptyCart({ userID }));
  const { minutes, seconds } = secondsToTime(countdown);

  const count = (cards && cards.length) || 0;
  const isEmpty = !cards || cards.length === 0;
  const cardTitle = getMessageByCount({
    messages: {
      oneItem: "card",
      moreThanOne: "cards"
    },
    count
  });

  return (
    <div className="cart-header">
      {isEmpty && <p className="empty-text">Your cart is empty</p>}
      {!isEmpty && !timeIsUp && (
        <div className="cart-timers">
          <p className="primary-timer">
            Your {cardTitle} are reserved for{" "}
            <span style={{ color: calculateTimerColor(countdown) }}>
              {minutes}:{String(seconds).padStart(2, "0")}
            </span>
          </p>
          <ProgressBar seconds={countdown} />
          <p className="secondary-timer">
            You have {count} {cardTitle} reserved in your cart for{" "}
            <span style={{ color: calculateTimerColor(countdown) }}>
              {minutes}:{String(seconds).padStart(2, "0")}
            </span>
          </p>
        </div>
      )}
    </div>
  );
};
